import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppTitleComponent } from '../core/components/app-title/app-title.component';
import { NavigateBackDirective } from '../toExtract/back-navigation/navigate-back.directive';

@Component({
  selector: 'pd-safety-standards',
  templateUrl: './safety-standards.component.html',
  styleUrls: ['./safety-standards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    NavigateBackDirective,
    MatIconModule,
    AppTitleComponent,
  ],
})
export class SafetyStandardsComponent {}
